var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { attrs: { header: "Relatórios" } },
        [
          _c(
            "b-card-group",
            { staticClass: "mt-3", attrs: { columns: "" } },
            _vm._l(_vm.cards, function(card, index) {
              return _c(
                "div",
                { key: index, staticClass: "mb-3 pb-3" },
                [
                  _vm.hasPermission(card.permission)
                    ? _c(
                        "b-card",
                        {
                          staticClass: "text-center card-relatorios",
                          attrs: {
                            "footer-bg-variant": "white",
                            "header-bg-variant": "secondary",
                            "border-variant": "primary",
                            header: card.header,
                            "header-tag": "header"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "footer",
                                fn: function() {
                                  return [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "buttoncard",
                                        attrs: {
                                          size: "sm",
                                          variant: "primary"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.setAction(card.action)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              Gerar\n            "
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _c("i", { class: card.icon + " fa-4x" }),
                          _vm._v(" "),
                          _c("b-card-text", { staticClass: "mt-3 text" }, [
                            _vm._v(_vm._s(card.text))
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            0
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-relatorio-item-varejo", {
        attrs: { state: _vm.modalVendaVarejo },
        on: { "update-modal": _vm.updateModalVenda }
      }),
      _vm._v(" "),
      _c("v-relatorio-varejo", {
        attrs: { state: _vm.modalVarejo },
        on: { "update-modal": _vm.update }
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: "Relatório de Atualização", size: "xl" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "downloadexcel",
                    {
                      staticClass: "btn btn-success mt-1",
                      attrs: {
                        size: "sm",
                        disabled: _vm.loadAtt,
                        name: _vm.showFilename,
                        worksheet: "Atualizacao de Cadastros",
                        title: "Atualizacao de Cadastros",
                        fetch: function() {
                          return _vm.geraRelatorioAtt()
                        }
                      }
                    },
                    [
                      _vm.loadAtt
                        ? _c("b-spinner", {
                            attrs: { small: "", label: "Spinning" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.loadAtt
                        ? _c("i", { staticClass: "fas fa-chart-bar" })
                        : _vm._e(),
                      _vm._v("\n        Gerar\n      ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { disabled: _vm.loadAtt, variant: "danger" },
                      on: {
                        click: function($event) {
                          _vm.modalAtualizacao = false
                        }
                      }
                    },
                    [_vm._v("Fechar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalAtualizacao,
            callback: function($$v) {
              _vm.modalAtualizacao = $$v
            },
            expression: "modalAtualizacao"
          }
        },
        [
          _c(
            "b-card",
            [
              _c(
                "b-row",
                [
                  _c("b-form-group", {
                    attrs: { label: "Tipo do Relatório" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var ariaDescribedby = ref.ariaDescribedby
                          return [
                            _c(
                              "b-form-radio",
                              {
                                attrs: {
                                  "aria-describedby": ariaDescribedby,
                                  name: "some-radios",
                                  value: "pendente"
                                },
                                model: {
                                  value: _vm.atualizacao.tipo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.atualizacao, "tipo", $$v)
                                  },
                                  expression: "atualizacao.tipo"
                                }
                              },
                              [_vm._v("Cadastros Com Atualização Pendente")]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-radio",
                              {
                                attrs: {
                                  "aria-describedby": ariaDescribedby,
                                  name: "some-radios",
                                  value: "atualizado"
                                },
                                model: {
                                  value: _vm.atualizacao.tipo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.atualizacao, "tipo", $$v)
                                  },
                                  expression: "atualizacao.tipo"
                                }
                              },
                              [_vm._v("Cadastros Atualizados")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Data De: ",
                            "label-for": "data-de",
                            description: "Data de atualização do cadastro."
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "data-de",
                              type: "date",
                              placeholder: "Data de",
                              required: ""
                            },
                            model: {
                              value: _vm.atualizacao.data_de,
                              callback: function($$v) {
                                _vm.$set(_vm.atualizacao, "data_de", $$v)
                              },
                              expression: "atualizacao.data_de"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Data Ate: ",
                            "label-for": "data-de",
                            description: "Data de atualização do cadastro."
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "data-de",
                              type: "date",
                              placeholder: "Data ate",
                              required: ""
                            },
                            model: {
                              value: _vm.atualizacao.data_ate,
                              callback: function($$v) {
                                _vm.$set(_vm.atualizacao, "data_ate", $$v)
                              },
                              expression: "atualizacao.data_ate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("b-row", [
                _c(
                  "span",
                  {
                    staticClass: "ml-3",
                    staticStyle: { "font-size": "14px", color: "#A9A9A9" }
                  },
                  [
                    _vm._v(
                      "Caso a data não seja informada, será gerado\n          relatório\n          dos últimos 90 dias!"
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: "Relatório de Prospectos", size: "xl" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "downloadexcel",
                    {
                      staticClass: "btn btn-success mt-1",
                      attrs: {
                        name: _vm.showFilename,
                        worksheet: "Acompanhamento Prospectos",
                        title: "Acompanhamento de cadastros",
                        fetch: function() {
                          return _vm.geraRelatorio()
                        },
                        "before-generate": _vm.exportExcel,
                        "before-finish": _vm.finishExcel
                      }
                    },
                    [_vm._v("\n        Gerar\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "danger" },
                      on: { click: _vm.showModal }
                    },
                    [_vm._v(" Fechar ")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalProspecto,
            callback: function($$v) {
              _vm.modalProspecto = $$v
            },
            expression: "modalProspecto"
          }
        },
        [
          _c(
            "b-card",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Data de: ",
                    "label-for": "data-de",
                    description: "Data de aprovação ou inativação do cadastro."
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "data-de",
                      type: "date",
                      placeholder: "Data de",
                      required: ""
                    },
                    model: {
                      value: _vm.params.data_de,
                      callback: function($$v) {
                        _vm.$set(_vm.params, "data_de", $$v)
                      },
                      expression: "params.data_de"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Data até: ",
                    "label-for": "data-ate",
                    description: "Data de aprovação ou inativação do cadastro."
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "data-ate",
                      type: "date",
                      placeholder: "Data até",
                      required: ""
                    },
                    model: {
                      value: _vm.params.data_ate,
                      callback: function($$v) {
                        _vm.$set(_vm.params, "data_ate", $$v)
                      },
                      expression: "params.data_ate"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Tipo: ",
                    "label-for": "tipo",
                    description:
                      "Tipo de relatório, Sintético / Analítico / Inativo"
                  }
                },
                [
                  _c("b-form-select", {
                    attrs: { options: _vm.options },
                    model: {
                      value: _vm.params.tipo,
                      callback: function($$v) {
                        _vm.$set(_vm.params, "tipo", $$v)
                      },
                      expression: "params.tipo"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-afb2ee4c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afb2ee4c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/relatorios/prospectos.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-afb2ee4c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/relatorios/prospectos.vue
// module chunks = 2